<template>
    <div class="screen">       
       <div class="row header">
            <topHeaderVip />
           
       </div>
       <div class="row content">
                <div  class="row row1" style="flex: 0.8;">
                    <div class="col" >
                        <cusbox txt="会员指标">
                              <div class="colgroup">
                                 <div class="group_item"><indicator topTxt="活跃会员"  bottomTxt="上日活跃会员"  topNum="50" bottomTxtNum="40"  bottomNum="5%"/></div>
                                 <div class="group_item"><indicator topTxt="新增会员"  bottomTxt="上日新增会员"  topNum="40" bottomTxtNum="30"  bottomNum="3%"/></div>
                                 <div class="group_item"><indicator topTxt="成交单数"  bottomTxt="上日成交单数"  topNum="35" bottomTxtNum="42"  bottomNum="2%" state="down"/></div>
                              </div>                             
                        </cusbox>
                    </div>
                    <div class="col col2">
                         <cusspecialbox txt="渠道会员占比">
                              <div class="mytt" slot="rc">
                                 <cusmenu  v-on:echange="echange" />
                              </div>
                              <div class="mtt">
                                   <barChart />
                              </div>
                         </cusspecialbox>
                    </div>
                   
                </div>
                <div class="row row2">
                     <div class="col rv" >                 
                        <div style="flex:1;display:flex">                              
                             <cusbox  v-show="(currentChange==1&&currentDate!=3)||(currentChange==2&&currentDate!=3)" txt="会员增长流失结构分析">
                                 <scaChart />
                             </cusbox>        
                              <cusbox  v-show="(currentChange==1&&currentDate==3)||(currentChange==2&&currentDate==3)" txt="客单价及件单价">
                                <div class="colgroup">
                                 <div class="group_item"><indicator topTxt="平均件单价"  bottomTxt="上日平均件单价"  topNum="549" bottomTxtNum="500" bottomNum="3%"/></div>
                               
                                 <div class="group_item"><indicator topTxt="平均客单价"  bottomTxt="上日平均客单价"  topNum="599" bottomTxtNum="530" bottomNum="2%" state="down"/></div>
                              </div>
                             </cusbox>                         
                        </div>
                        <div style="flex:1.5;display:flex;margin-top:16px">                          
                              <cusbox  txt="会员等级及活跃度">
                                   <div class="vcontent" >
                                        <div style="vrow1">
                                               <div class="row">
                                                    <div  class="vitem">
                                                         <div class="vt1">V1会员</div>
                                                         <div>1.2万</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">V2会员</div>
                                                         <div>1.2万</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">V3会员</div>
                                                         <div>1.2万</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">V4会员</div>
                                                         <div>1.2万</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">V5会员</div>
                                                         <div>1.2万</div>
                                                    </div>
                                               </div>
                                               <div class="row" style="margin-top:10px">
                                                            <div  class="vitem">
                                                         <div class="vt1">活跃会员</div>
                                                         <div>3000</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">活跃会员</div>
                                                         <div>3000</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">活跃会员</div>
                                                         <div>3000</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">活跃会员</div>
                                                         <div>3000</div>
                                                    </div>
                                                    <div  class="vitem">
                                                         <div  class="vt1">活跃会员</div>
                                                         <div>3000</div>
                                                    </div>
                                               </div>           
                                                <div class="row">
                                                  <div style="color:#C0C8FF;margin-left:20px;margin-top:10px">
                                                    会员销售占比
                                                  </div>                                                  
                                              </div>                                   
                                        </div>
                                        <div style="flex:1;min-height: 100px;">
                                             
                                              <div class="row" style="height:100%">
                                                    <div class="vitem">
                                                       <pieChartM :num="20"/>
                                                    </div>
                                                    <div  class="vitem">
                                                        <pieChartM :num="40"/>
                                                    </div>
                                                    <div  class="vitem">
                                                         <pieChartM :num="50"/>
                                                    </div>
                                                    <div  class="vitem">
                                                        <pieChartM :num="70"/>
                                                    </div>
                                                    <div  class="vitem">
                                                         <pieChartM :num="90"/>
                                                    </div>
                                               </div>
                                        </div>
                                        <div style="flex:1;  flex-direction: column;display:flex; width:90%;background:#040B4C;margin:auto;">
                                            
                                               <div class="row">
                                                    <div  class="vitem2" style="background:#050B5C ">
                                                         客单价                                                         
                                                    </div>
                                                    <div  class="vitem2">
                                                         1100                                                       
                                                    </div>
                                                    <div  class="vitem2">
                                                         460                                                      
                                                    </div>
                                                    <div  class="vitem2">
                                                         312                                                        
                                                    </div>
                                                    <div  class="vitem2">
                                                        98                                                       
                                                    </div>
                                                     <div  class="vitem2">
                                                        14                                                       
                                                    </div>
                                               </div>
                                               <div class="row" >
                                                    <div  class="vitem2" style="background:#050B5C ">
                                                         件单价                                                         
                                                    </div>
                                                    <div  class="vitem2">
                                                         1100                                                       
                                                    </div>
                                                    <div  class="vitem2">
                                                         460                                                      
                                                    </div>
                                                    <div  class="vitem2">
                                                         312                                                        
                                                    </div>
                                                    <div  class="vitem2">
                                                        98                                                       
                                                    </div>
                                                     <div  class="vitem2">
                                                        14                                                       
                                                    </div>
                                               </div>                                              
                                          
                                        </div>
                                        <div style="flex:0.1"></div>
                                   </div>
                              </cusbox>                              
                        </div>                        
                    </div>
                    <div class="col col2 rv" >
                        <div style="flex:1;display:flex">
                            <div  style="display:flex;flex:1;height:100%;padding-right: 16px;">
                                   <div  v-show="currentChange==2" style="flex:1;padding-right: 16px;">
                                    <cusbox txt="会员消费排行 TOP50">
                                        <pieChartD  :num="20" />
                                    </cusbox>
                                     </div>    
                                    <div v-show="currentChange==2"  style="flex:1;">
                                            <cusbox txt="年龄趋势分析">
                                                <pieChartD  :num="30"/>
                                            </cusbox>
                                    </div>
                                    <div  v-show="currentChange==1" style="flex:1;">
                                            <cusbox txt="活跃会员门店排行 TOP20">
                                            <barChartX />
                                        </cusbox>
                                    </div>
                            </div>
                               
                                <div style="flex:1;">
                                   <cusbox  v-show="(currentChange==1&&currentDate!=3)||(currentChange==2&&currentDate!=3)"  txt="会员结构分析">
                                      <div style="display:flex; height: 100%;">
                                          <div style="flex:1">
                                            <pieChart title="会员结构"/>
                                          </div>
                                          <div style="flex:1">
                                            <pieChart title="活跃会员结构" />
                                          </div>
                                      </div>
                                   </cusbox>

                                   <cusbox  v-show="(currentChange==1&&currentDate==3)||(currentChange==2&&currentDate==3)"  txt="会员连带率">
                                      <div style="display:flex; height: 100%;">
                                          <div style="flex:1">
                                                <barChartY />
                                          </div>                                         
                                      </div>
                                   </cusbox>
                                </div>
                               
                        </div>
                        <div style="flex:1;display:flex;margin-top:16px">
                            <div style="display:flex;flex:1;padding-right: 16px;height:100%">
                                  <div style="flex:1;padding-right: 16px;">
                                        <cusbox txt="面料购买区间">
                                            <lineChart />
                                            
                                        </cusbox>
                                    </div>
                                    <div style="flex:1;">
                                            <cusbox txt="单价购买区间">
                                                <lineChart lineColor="#F7517F"/>
                                                
                                            </cusbox>
                                    </div>
                            </div>
                            <div  style="display:flex;flex:1;height:100%">
                                   <div  v-show="(currentChange==1&&currentDate!=3)||(currentChange==2&&currentDate==1)" style="flex:1;padding-right: 16px;">
                                    <cusbox txt="会员消费排行 TOP50">
                                        <barChartX :radius="radius" />
                                    </cusbox>
                                     </div>    
                                    <div  v-show="(currentChange==1&&currentDate!=3)||(currentChange==2&&currentDate==1)" style="flex:1;">
                                            <cusbox txt="年龄趋势分析">
                                                <lineChart lineColor="#4EADFF"/>
                                            </cusbox>
                                    </div>
                                    <div  v-show="(currentChange==1&&currentDate==3)||(currentChange==2&&currentDate!=1)" style="flex:1;">
                                        <cusbox txt="会员消费排行 TOP10">
                                            <barChartX />
                                        </cusbox>
                                    </div>
                            </div>                             
                            
                        </div>                                            
                       
                    </div>
                </div>
       </div>
    </div>
</template>
<style lang="scss">
    *{
        box-sizing: border-box;
    } 
    body,html{
        height: 100%;
    }
   .screen{           
       background-size: 100% 100%;
       background-image: url(../../assets/bg.png);
       display: flex;
       flex-direction: column;
       height: 100%;
       min-width: 1280px;
       min-height: 720px;
       .vcontent{ 
           color:#fff;
           font-size: 14px;           
           display: flex;
           flex-direction: column;
           height: 100%;
           padding-top: 20px;
        
           .vrow1{
               flex:1.5;display: flex;flex-direction: column;height: 100%;
           }
           .vitem{
               flex:1;display: flex;flex-direction: column;
               align-items: center;
               .vt1{
                   color:#C0C8FF;
               }
           }
           .vitem2{
               flex:1;display: flex;flex-direction: column;
               align-items: center;
                   justify-content: center;
               
           }
        
       }
       .mytt{
        position: absolute;
        right: -2px;
        left: 30px;
        top: -15px;
        height: 36px;     
       }
       .mtt{
           height:100%;padding-bottom: 20px;margin-top: -30px;
       }
       
       .rv{
           flex-direction: column;
       }
       .row.header{
           height: 80px;
           flex: none;
       }
       .row.content{
            flex-direction: column;
            padding: 8px 10px;           
       }
       .row{
           display:flex;
           flex:1;
           .col{  
               flex:1;
               padding: 8px;
               display: flex;
               
           }
           .col.col2{  
                   flex:2;              
                }
       }
       .row.row1{
          min-height: 164px;
          flex:1;
       }
        .row.row2{
          flex:2;
          min-height: 164px;
       }

       .colgroup{
           display: flex;   
            flex: 1;
            align-items: center;
           .group_item{
               flex:1
           }
       }
   }
</style>
<script>
import topHeaderVip from "@/components/topHeaderVip"
import cusbox from "@/components/vip/cusbox"
import indicator from "@/components/vip/indicator"
import cusspecialbox from "@/components/vip/cusspecialbox"
import cusmenu from "@/components/vip/cusmenu"
import {barChart,barChartX,pieChart,lineChart,pieChartM,scaChart,barChartY,pieChartD} from "@/components/vip/charts"

  
export default {
    data(){
       return {
          radius:[0,0,0,0],
          currentChange:1,
          currentDate:1,
         
       }
    },
    methods:{
        echange(data){
            var that=this;
            this.currentChange=data.currentChange;
            this.currentDate=data.currentDate;                 
        }
    },
     components: {
        topHeaderVip,
        cusbox,
        indicator,
        cusspecialbox,
        cusmenu,
        barChart,
        barChartX,
        pieChart,
        lineChart,
        pieChartM,
        scaChart,
        barChartY,
        pieChartD        
    }
}
</script>